import type { Router } from 'vue-router'
import { App, type URLOpenListenerEvent } from '@capacitor/app'

function resolveInAppPath(url: string): string | null {
  try {
    const parsed = new URL(url)
    const host = parsed.hostname.toLowerCase()

    if (host === 'app.dhikrsession.com' || host.endsWith('.dhikrsession.com')) {
      return `${parsed.pathname}${parsed.search}${parsed.hash}`
    }

    if (parsed.protocol === 'dhikrsession:' || parsed.protocol === 'com.dhikr.dhikrsession:') {
      return `${parsed.pathname}${parsed.search}${parsed.hash}`
    }
  } catch {
    if (url.startsWith('/')) return url
  }

  return null
}

export function registerDeepLinkHandler(router: Router): void {
  App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
    const path = resolveInAppPath(event.url)
    if (path) {
      router.push(path)
    }
  })
}
